import { FunctionComponent, memo } from "react";
import { IProps } from "./multiple-comparison-table-columns.types";
import ComparisonTableTagColumn from "./comparison-table-tag-column";
import { Cell, Column, Heading } from "@edgetier/client-components";
import createPersistedState from "use-persisted-state";
import { LIMIT_CUSTOM_TAG_COLUMN } from "./multiple-comparison-table-columns.constants";
import "./multiple-comparison-table-columns.scss";
import { PersistedStorageKeys } from "constants/persisted-storage-keys";

const useTagSelected = createPersistedState<string[]>(PersistedStorageKeys.TagSelected);
const useTagGroupSelected = createPersistedState<string[]>(PersistedStorageKeys.TagGroupSelected);

/**
 * Display multiple custom tag columns and a button to add a new column
 * @param props.isComparisonDataLoading Loading flag for data
 * @param props.showPercentage          Display percentage flag
 * @param props.overallComparisonData   Data displayed for overall
 */
const MultipleComparisonTableColumns: FunctionComponent<IProps> = ({
    isComparisonDataLoading,
    showPercentage,
    overallComparisonData,
}) => {
    const [tagSelected, setTagSelected] = useTagSelected([]);
    const [, setTagGroupSelected] = useTagGroupSelected([]);

    return (
        <>
            {tagSelected.map((_, index) => (
                <ComparisonTableTagColumn
                    key={index}
                    customColumnIndex={index}
                    isMaybeLoading={isComparisonDataLoading}
                    showPercentage={showPercentage}
                    overallComparisonData={overallComparisonData}
                />
            ))}
            {tagSelected.length < LIMIT_CUSTOM_TAG_COLUMN && (
                <Column>
                    <Heading>
                        <button
                            type="button"
                            className="comparison-table__add-column"
                            onClick={() => {
                                setTagSelected((values) => {
                                    if (Array.isArray(values)) {
                                        return [...values, ""];
                                    }
                                    return values;
                                });
                                setTagGroupSelected((values) => {
                                    if (Array.isArray(values)) {
                                        return [...values, ""];
                                    }
                                    return values;
                                });
                            }}
                        >
                            Add Column
                        </button>
                    </Heading>
                    <Cell<any>>{() => <div></div>}</Cell>
                </Column>
            )}
        </>
    );
};

export default memo(MultipleComparisonTableColumns);
